module.exports = __webpack_public_path__ + "static/img/dingdan_53@2x.8fc6b74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/dingdan_53@2x.png
// module id = xq/d
// module chunks = 177